"use strict";
/**
 * TypeScript types for v9 ProviderMatch Provider
 *
 * Basic type information was constructed using information from the following Search API models:
 *  - https://bitbucket.org/kyruus/scheduling_models/src/master/scheduling_models/domains/
 *  - https://bitbucket.org/kyruus/scheduling_configuration_service/src/master/scheduling_configuration_service/models/external/providermatch.py
 *
 * Additional type information and description text was extracted from the official documentation found here:
 *  - https://bitbucket.org/kyruus/doc/src/master/api/provider_search/
 *
 * To better facilitate maintenance of these types the following eslint rules are strictly enforced:
 *  - fields must be in alphabetical order
 *  - explicit use of `any` type is forbidden
 *
 * All types, export interfaces, and fields should be documented fully and may be annotated with the following:
 *  - `@deprecated` - type has been deprecated and should not be used
 *
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=types.js.map